import Environment from '../environment';
import { getLogger } from '../logging/logger';

const logger = getLogger('FontLoader');

export default class FontLoader {
	static preloadDocumentFonts() {
		logger.log('[preloadDocumentFonts]');
		if (Environment.isVerizonSetTopBox()) {
			// Font preloading crashes Verizon 1100 boxes
			return Promise.resolve();
		}
		// TODO Verify this now works on verizon devices after fixing Opera 40 compatibility and remove the guard above
		return Promise.all(Array.from(document.fonts.values()).map((font) => font.load())).catch(
			(error) => {
				logger.error('[Error preloading fonts]', { error });
			},
		);
	}
}
